export default __webpack_public_path__ + "static/media/ally_l2.83db443a.png";